import React, { Component } from 'react'
import { bool } from 'prop-types'

import { visit } from 'utils/tracker'

import SignupLogin from 'components/accountAccess/SignupLogin'

class SignupLoginContainer extends Component {
    componentDidMount() {
        if (this.props.isLogin) {
            visit('Login')
        } else {
            visit('Signup')
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isLogin !== this.props.isLogin) {
            if (this.props.isLogin) {
                visit('Login')
            } else {
                visit('Signup')
            }
        }
    }

    render() {
        const { isLogin } = this.props
        return <SignupLogin isLogin={isLogin} />
    }
}

SignupLoginContainer.defaultProps = {
    isLogin: false,
}

SignupLoginContainer.propTypes = {
    isLogin: bool,
}

export default SignupLoginContainer
